// This function is used to transfer holiday dates to the next working day if the holiday falls on a non-working day
export const transferHolidayDates = (workWeek: number[], startDate: Date, endDate?: Date): { startDate: Date; endDate?: Date } => {
  
  if (endDate) {
    let currentDate = new Date(startDate)
    const workingDaysNeeded = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
    const adjustedStartDate = getNextWorkingDay(currentDate, workWeek)
    
    currentDate = new Date(adjustedStartDate)
    let workingDaysCount = 1
    
    while (workingDaysCount < workingDaysNeeded) {
      currentDate.setDate(currentDate.getDate() + 1)
      if (workWeek.includes(currentDate.getDay() || 7)) {
        workingDaysCount++
      }
    }
    startDate = adjustedStartDate
    endDate = currentDate
  } else {
    startDate = getNextWorkingDay(startDate, workWeek)
  }

  return { startDate, endDate }
}

const getNextWorkingDay = (date: Date, workWeek: number[]): Date => {
  const newDate = new Date(date)
  while (!workWeek.includes(newDate.getDay() || 7)) { // Convert Sunday (0) to 7
    newDate.setDate(newDate.getDate() + 1)
  }
  return newDate
}